import { bindActionCreators, } from 'redux'
import { connect, } from 'react-redux'

import {
  navAddTrip,
  navEditTrip,
  navViewAllTrips,
  navViewTripAsMap,
  navViewTripAsList,
} from 'redux/actions'
import {
  appMode,
  existingTripIds,
  selectedTripId,
  listingMode,
  addingTrip,
  editingTrip,
  selectedEventId,
  selectedEventInfoDisplayed,
} from 'redux/reducers'

import Component from './component'

const mapStateToProps = state => ({
  appMode: appMode(state),
  location: state.location,
  existingTripIds: existingTripIds(state),
  selectedTripId: selectedTripId(state),
  addingTrip: addingTrip(state),
  editingTrip: editingTrip(state),
  listingMode: listingMode(state),
  selectedEventId: selectedEventId(state),
  selectedEventInfoDisplayed: selectedEventInfoDisplayed(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      navAddTrip,
      navEditTrip,
      navViewAllTrips,
      navViewTripAsList,
      navViewTripAsMap,
    },
    dispatch
  ),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./src/components/_sceneManager/index.js